// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {Nav_menu} from './nav_menu';
import {Nav_user} from './nav_user';
import {use_navbar} from './use_navbar';
import {Logo} from '../../lib/logo';
import styles from './nav.module.less';

export const Nav = (props: ReturnType<typeof use_navbar>)=>{
    const {is_scrolled, has_user, headlogo, nav_opt, cp_link,
        cp_after_login, is_navigating, opened, toggle} = props;
    const {theme} = use_theme({def: 'oculus'});
    const variant = nav_opt?.transparent ? 'transparent' : 'default';
    const nav_cls = cn(styles.nav, theme.root, styles[variant], {
        [styles.scrolled]: is_scrolled,
        [styles.opened]: opened,
    });
    const show_nav_menu = !headlogo;
    return <div className={nav_cls}>
      <div className={styles.container}>
        <Logo clickid="nav_logo"/>
        {show_nav_menu && <Nav_menu visible={!is_navigating} toggle={toggle}/>}
        {headlogo ? <div/> : <Nav_user has_user={has_user}
          is_scrolled={is_scrolled}
          cp_link={cp_link} cp_after_login={cp_after_login}/>}
      </div>
    </div>;
};
